import Vue from 'vue';
import * as TYPES from './types';
import http from '@/utils/api';
import httpV2 from '@/utils/apiV2';
import Auth from '@/utils/auth';
import configService, { getErrorStatus } from '@/services/config';

const MTS_CONTRACT_TYPE_MODES = ['legacy', 'buyout', 'tradein', 'both'];

const namespaced = true;

const state = () => ({
  isLoading: false,
  error: {
    ErrorCode: null,
    message: '',
  },
  user: null,
})

const actions = {
  async refreshMtsContractTypeMode ({ state, commit }) {
    if (!state.user || state.user.type !== 1 || state.user.flowType !== 'mts') {
      return { skipped: true };
    }

    try {
      const response = await httpV2.get('/store/mts-mode', {
        headers: { Authorization: Auth.getAuthHeader() },
        timeout: 5000,
      });
      const mode = response && response.data && response.data.mtsContractTypeMode;
      if (!MTS_CONTRACT_TYPE_MODES.includes(mode)) {
        const error = new Error('Ответ режима MTS имеет неизвестное значение');
        error.code = 'INVALID_MTS_CONTRACT_TYPE_MODE';
        throw error;
      }

      commit(TYPES.SET_USER, { ...state.user, mtsContractTypeMode: mode });
      Vue.$storage.set('user-info', { ...state.user, mtsContractTypeMode: mode });
      return { refreshed: true };
    } catch (error) {
      if (getErrorStatus(error) === 404) return { unavailable: true };
      throw error;
    }
  },

  async authorize ({ commit }, data) {
    console.log(data)
    configService.clear();
    commit(TYPES.SET_ERROR, { ErrorCode: null, message: '', });
    commit(TYPES.SET_LOADING, { status: true, });
    try {
      const response = await http.post('/login', data);
      const result = response.data;

      if ([401, 403].includes(result.ErrorCode)) commit(TYPES.SET_ERROR, result);
      if (result && result.key && result.user) {
        commit(TYPES.SET_USER, result.user);
        Vue.$storage.set('token', result.key);
        Vue.$storage.set('user-info', result.user);

        if (result.user.type === 1) {
          try {
            await configService.preload();
          } catch (configError) {
            if (getErrorStatus(configError) === 401) {
              commit(TYPES.USER_LOGOUT);
              commit(TYPES.SET_ERROR, {
                ErrorCode: 401,
                message: 'Сессия истекла. Войдите повторно.',
              });
              return { ...result, user: null };
            }
          }
        }
      }

      return result;
    } catch(e) {
      console.log(e);
    } finally {
      commit(TYPES.SET_LOADING, { status: false, });
    }
  },
}

const mutations = {
  [TYPES.SET_LOADING](state, payload) {
    state.isLoading = payload.status;
  },

  [TYPES.SET_ERROR](state, payload) {
    state.user = null;
    state.error = payload;
  },

  [TYPES.SET_USER](state, payload) {
    console.log(payload)
    state.user = payload;
  },

  [TYPES.USER_LOGOUT](state, payload) {
    state.user = null;
    Vue.$storage.remove('token');
    Vue.$storage.remove('user-info');
    configService.clear();
    // localStorage.removeItem('token');
    // localStorage.removeItem('user-info');
  },
}

export default {
  namespaced,
  actions,
  state,
  mutations,
};
